import { Component, ContentChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TopbarComponent } from '../../../core/components/topbar/topbar.component';
import { LanguageSlotDirective } from '../../directives/language-slot.directive';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
  imports: [TopbarComponent, TranslateModule],
})
export class LayoutComponent {
  /**
   * Queries for projected language-related content provided via {@link LanguageSlotDirective}.
   * When set, this content is used to render language selection elements in the layout.
   */
  @ContentChild(LanguageSlotDirective) languageEl?: LanguageSlotDirective;

  /**
   * Indicates whether language selection UI should be displayed.
   * Returns `true` when projected language content is available via {@link languageEl}.
   */
  get hasLanguage(): boolean {
    return !!this.languageEl;
  }

  skipToMain(event: Event): void {
    event.preventDefault();
    const main = document.getElementById('main-content');
    if (main) {
      // Ensure element can be focused
      (main as HTMLElement).focus();
    }
  }
}
